import { render, staticRenderFns } from "./ResetPasswordRequest.vue?vue&type=template&id=d07b4fc6&scoped=true&"
import script from "./ResetPasswordRequest.vue?vue&type=script&lang=js&"
export * from "./ResetPasswordRequest.vue?vue&type=script&lang=js&"
import style0 from "./ResetPasswordRequest.vue?vue&type=style&index=0&id=d07b4fc6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d07b4fc6",
  null
  
)

export default component.exports